<template>
    <div class="row">
        <div class="col-lg-12 mb-3">
        <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
            <b-card :header="$t('general.subcontractors.title')" header-tag="h3" class="bg-default-card">
                <data-table
                    v-if="tableLoaded"
                    :exportable = "false" title=""
                    :rows="getData.rowData"
                    :columns="columnData"
                    :paginate="false"
                    @rowClickDelete="onDeleteRow"
                    @rowClickEdit="onEditRow"
                    @rowClickCheckSubcontractors="onClickCheckSubcontractors"
                    @rowClickPricelist="onClickPriceList"
                    @changePage="changePage"
                    @searchEvent="searchEvent"
                    @orderByEvent="orderByEvent"
                    >
                </data-table>

                <b-btn class="btn btn-default mt-3 mr-2" v-if="this.$store.getters.hasPermission(['project_subcontractors'], ['create'])" @click="onAddRow"><i class="fa fa-plus-circle mr-1"></i>{{ $t('general.subcontractors.subcontractors_profile.create_button') }}</b-btn>
            </b-card>

            <div class="row" v-if="getData.rowData.length > 0">
                <div class="col-sm-12">
                    <i class="fa fa-2x fa-money-bill text-info" style="color:green !important"></i> - {{$t('general.buttons.price_list')}}
                </div>
            </div>

            <b-modal ref="saveModal" :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" :title="actionTitle" size="lg" @ok="saveAction">
                <div class="row">
                    <div class="col-lg-6">
                        <div v-if="row">
                            <div class="row mb-3">
                                <div class="col-lg-4">
                                    <label for="name">{{ $t('table.name') }}</label>
                                </div>
                                <div class="col-lg-8">
                                    <input type="text" maxlength="50" class="form-control" v-model="model.name"/>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <div class="row mb-3" v-if="isSubcontractor">
                                <div class="col-lg-4">
                                    <label for="name">{{ $t('table.name') }}</label>
                                </div>
                                <div class="col-lg-8">
                                    <input type="text" maxlength="50" class="form-control" v-model="model.name"/>
                                </div>
                            </div>
                            
                            <div class="row mb-3" v-else>
                                <div class="col-lg-4">
                                    <label for="name">{{ $t('table.name') }}</label>
                                </div>
                                <div class="col-lg-8">
                                    <multiselect v-model="selectedCompany"
                                        :options="currentCompany"
                                        :multiple="false"
                                        :clear-on-select="true"
                                        :hide-selected="false"
                                        :loading="isCompanyLoading"
                                        :preserve-search="true"
                                        placeholder=""
                                        label="name" track-by="id"
                                        :selectLabel="''"
                                        @search-change="onCompanySearch"
                                        @input="updateCompany"
                                    >
                                        <template slot="clear" slot-scope="props">
                                            <div 
                                                v-if="selectedCompany != null" 
                                                class="multiselect__clear" 
                                                @mousedown.prevent.stop="clearSelectedCompany"
                                            >
                                            </div>
                                        </template>
                                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                                    </multiselect>
                                </div>
                            </div>

                            <div class="row mb-3" v-if="model.company_id != null">
                                <div class="col-lg-4">
                                    <label>{{ $t('table.project_manager') }}</label>
                                </div>
                                <div class="col-lg-8">
                                    <multiselect v-model="selectedPM"
                                        :options="currentPM"
                                        :multiple="false"
                                        :clear-on-select="true"
                                        :hide-selected="false"
                                        :loading="isPMLoading"
                                        :preserve-search="true"
                                        placeholder=""
                                        label="fullname" track-by="id"
                                        :selectLabel="''"
                                        @search-change="onPMSearch"
                                        @input="updatePM"
                                    >
                                        <template slot="clear" slot-scope="props">
                                            <div 
                                                v-if="selectedPM != null" 
                                                class="multiselect__clear" 
                                                @mousedown.prevent.stop="clearSelectedPM"
                                            >
                                            </div>
                                        </template>
                                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                                    </multiselect>
                                </div>
                            </div>

                            <div class="row mb-3" v-if="model.company_id != null">
                                <div class="col-lg-4">
                                    <label for="commercial_manager">{{ $t('table.commercial_manager') }}</label>
                                </div>
                                <div class="col-lg-8">
                                    <multiselect v-model="selectedCM"
                                        :options="currentCM"
                                        :multiple="false"
                                        :clear-on-select="true"
                                        :hide-selected="false"
                                        :loading="isCMLoading"
                                        :preserve-search="true"
                                        placeholder=""
                                        label="fullname" track-by="id"
                                        :selectLabel="''"
                                        @search-change="onCMSearch"
                                        @input="updateCM"
                                    >
                                        <template slot="clear" slot-scope="props">
                                            <div 
                                                v-if="selectedCM != null" 
                                                class="multiselect__clear" 
                                                @mousedown.prevent.stop="clearSelectedCM"
                                            >
                                            </div>
                                        </template>
                                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                                    </multiselect>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="contract_done">{{ $t('table.contract_done') }}</label>
                            </div>
                            <div class="col-lg-8" style="z-index: 0">
                                <toggle-button v-model="model.contract_done" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="performance_bond">{{ $t('table.performance_bond') }}</label>
                            </div>
                            <div class="col-lg-8" style="z-index: 0">
                                <toggle-button v-model="model.performance_bond" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                            </div>
                        </div>

                        <div class="row mb-2" v-if="model.performance_bond==1">
                            <div class="col-lg-4">
                                <label for="performance_bond_value">{{ $t('table.performance_bond_value') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.performance_bond_value"/>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="performance_bond_received">{{ $t('table.performance_bond_received') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2" style="z-index: 0">
                                <toggle-button v-model="model.performance_bond_received" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                            </div>
                        </div>

                        <div class="row mb-2" v-if="model.performance_bond_received==1">
                            <div class="col-lg-4">
                                <label for="performance_bond_received_date">{{ $t('table.performance_bond_received_date') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.performance_bond_received_date"></flat-pickr>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="warranty_bond">{{ $t('table.warranty_bond') }}</label>
                            </div>
                            <div class="col-lg-8" style="z-index: 0">
                                <toggle-button v-model="model.warranty_bond" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                            </div>
                        </div>

                        <div class="row mb-2" v-if="model.warranty_bond==1">
                            <div class="col-lg-4">
                                <label for="warranty_received">{{ $t('table.warranty_received') }}</label>
                            </div>
                            <div class="col-lg-8" style="z-index: 0">
                                <toggle-button v-model="model.warranty_received" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                            </div>
                        </div>

                        <div class="row mb-2" v-if="model.warranty_bond==1">
                            <div class="col-lg-4">
                                <label for="warranty_value">{{ $t('table.warranty_value') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.warranty_value"/>
                            </div>
                        </div>

                        <div class="row mb-2" v-if="model.warranty_bond==1">
                            <div class="col-lg-4">
                                <label for="expiry_date">{{ $t('table.auth_date') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.expiry_date"></flat-pickr>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="penalty_for_late_payment">{{ $t('table.penalty_for_late_payment') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <input type="text" maxlength="50" class="form-control" v-model="model.penalty_for_late_payment"/>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="penalty_date_agreed_1">{{ $t('table.1st_penalty_date') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.penalty_date_agreed_1"></flat-pickr>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="penalty_date_agreed_1_description">{{ $t('table.1st_penalty_date_description') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <textarea rows="6" maxlength="5000" class="form-control resize_vertical" v-model="model.penalty_date_agreed_1_description"></textarea>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="penalty_date_agreed_2">{{ $t('table.2nd_penalty_date') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.penalty_date_agreed_2"></flat-pickr>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="penalty_date_agreed_2_description">{{ $t('table.2nd_penalty_date_description') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <textarea rows="6" maxlength="5000" class="form-control resize_vertical" v-model="model.penalty_date_agreed_2_description" ></textarea>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="penalty_date_agreed_3">{{ $t('table.3rd_penalty_date') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.penalty_date_agreed_3"></flat-pickr>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="penalty_date_agreed_3_description">{{ $t('table.3rd_penalty_date_description') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <textarea rows="6" maxlength="5000" class="form-control resize_vertical" v-model="model.penalty_date_agreed_3_description"></textarea>
                            </div>
                        </div>

                    </div>
                    <div class="col-lg-6">
                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="penalty_date_agreed_4">{{ $t('table.4th_penalty_date') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.penalty_date_agreed_4"></flat-pickr>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="penalty_date_agreed_4_description">{{ $t('table.4th_penalty_date_description') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <textarea rows="6" maxlength="5000" class="form-control resize_vertical" v-model="model.penalty_date_agreed_4_description"></textarea>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="penalty_date_agreed_5">{{ $t('table.5th_penalty_date') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.penalty_date_agreed_5"></flat-pickr>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="penalty_date_agreed_5_description">{{ $t('table.5th_penalty_date_description') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <textarea rows="6" maxlength="5000" class="form-control resize_vertical" v-model="model.penalty_date_agreed_5_description"></textarea>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="invoices_submitted">{{ $t('table.invoices_submitted') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.invoices_submitted"></textarea>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="contract_currency">{{ $t('table.contract_currency') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <select v-model="model.contract_currency" class="form-control" size="1">
                                    <option v-for="currency in currencies" :value="currency.code">{{currency.name}}</option>
                                </select>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="contract_value">{{ $t('table.contract_value') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control"  v-model="model.contract_value"/>
                            </div>
                        </div>

                        <div class="row mb-3" v-if="row != null">
                            <div class="col-lg-4">
                                <label for="percentage_of_completion">{{ $t('table.percentage_of_completion') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <input type="text" maxlength="50" class="form-control" v-model="model.percentage_of_completion" disabled/>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="start_date">{{ $t('table.start_date') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.start_date"></flat-pickr>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="end_date">{{ $t('table.end_date') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.end_date"></flat-pickr>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="additional_services_agreed">{{ $t('table.additional_services_agreed') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <textarea rows="6" maxlength="5000" class="form-control resize_vertical" v-model="model.additional_services_agreed"></textarea>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="submitted_documentation">{{ $t('table.submitted_documentation') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <toggle-button v-model="model.submitted_documentation" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                            </div>
                        </div>

                        <div class="row mb-2" v-if="model.submitted_documentation==1">
                            <div class="col-lg-4">
                                <label for="submitted_date">{{ $t('table.submitted_date') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.submitted_date"></flat-pickr>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="as_build_doc_rec_and_checked">{{ $t('table.as_build_doc_rec_and_checked') }}</label>
                            </div>
                            <div class="col-lg-8 mt-2">
                                <toggle-button v-model="model.as_build_doc_rec_and_checked" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="as_build_doc_needed">{{ $t('table.as_build_doc_needed') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <toggle-button v-model="model.as_build_doc_needed" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-lg-4">
                                <label for="po_number">{{ $t('table.po_number') }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="model.po_number"/>
                            </div>
                        </div>
                    </div>
                </div>
            </b-modal>
            
            <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
                {{ $t('messages.delete') }}
            </confirm-dialog>
        </div>
    </div>
</template>
<script>

import Vue from 'vue';
import VueForm from "vue-form";
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import vue2Dropzone from 'vue2-dropzone';
import '@/assets/css/vue2Dropzone.css';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import http from '@/libs/http';
import miniToastr from 'mini-toastr';
import ToggleButton from 'vue-js-toggle-button'
import Multiselect from 'vue-multiselect';

Vue.component(Multiselect);

export default {
    name: 'subcontractors',
    components: {
        DataTable,
        flatPickr,
        Multiselect,
        ConfirmDialog,
        notificationIcons,
        vueDropzone: vue2Dropzone
    },
    computed: {
        currencies: {
            get: function () {
                let currencies = this.$store.getters.getCurrencies;
                return currencies;
            }
        }
    },
    watch: {
        currencies: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.subcontractors.title'),
                    active: true
                }
            ],
            tableName: 'company',
            tableNameTranslated: Vue.i18n.translate('general.subcontractors.subcontractors_profile.title_modal'),
            actionTitle: '',
            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',

            isSubcontractor: false,

            selectedCompany: null,
            currentCompany: [],
            isCompanyLoading: false,

            selectedPM: null,
            currentPM: [],
            isPMLoading: false,

            selectedCM: null,
            currentCM: [],
            isCMLoading: false,

            getData: {
                rowData: []
            },

            model: {
                name: null,

                company_id: null,
                project_manager_id: null,
                commercial_manager_id: null,

                contract_done: false,
                performance_bond: false,
                performance_bond_value: null,
                performance_bond_received: false,
                performance_bond_received_date: null,
                warranty_bond: false,
                warranty_received: false,
                warranty_value: null,
                expiry_date: null,
                penalty_for_late_payment: null,
                contract_currency: null,
                contract_value: null,
                penalty_date_agreed_1: null,
                penalty_date_agreed_1_description: null,
                penalty_date_agreed_2: null,
                penalty_date_agreed_2_description: null,
                penalty_date_agreed_3: null,
                penalty_date_agreed_3_description: null,
                penalty_date_agreed_4: null,
                penalty_date_agreed_4_description: null,
                penalty_date_agreed_5: null,
                penalty_date_agreed_5_description: null,
                percentage_of_completion: null,
                start_date: null,
                end_date: null,
                additional_services_agreed: null,
                invoices_submitted: null,
                submitted_documentation: false,
                submitted_date: null,
                as_build_doc_rec_and_checked: false,
                as_build_doc_needed: false,
                po_number: null
            },
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '100px',
                    field: '',
                    // showDeleteButton: true,
                    showEditButton: true,
                    showPricelistButton: true,
                },
                {
                    label: Vue.i18n.translate('table.company'),
                    width: '135px',
                    field: 'name',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.contract_done'),
                    field: 'company2project.contract_done',
                    numeric: false,
                    html: false,
                    showAsCheckSubcontractors: true,
                }, {
                    label: Vue.i18n.translate('table.performance_bond'),
                    field: 'company2project.performance_bond',
                    numeric: false,
                    html: false,
                    showAsCheckSubcontractors: true,
                }, {
                    label: Vue.i18n.translate('table.performance_bond_received'),
                    field: 'company2project.performance_bond_received',
                    numeric: false,
                    html: false,
                    showAsCheckSubcontractors: true,
                }, {
                    label: Vue.i18n.translate('table.penalty_for_late_payment'),
                    field: 'company2project.penalty_for_late_payment',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.contract_currency'),
                    field: 'company2project.contract_currency',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.contract_value'),
                    field: 'company2project.contract_value',
                    numeric: true,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.1st_penalty_date'),
                    field: 'company2project.penalty_date_agreed_1',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.2nd_penalty_date'),
                    field: 'company2project.penalty_date_agreed_2',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.3rd_penalty_date'),
                    field: 'company2project.penalty_date_agreed_3',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.4th_penalty_date'),
                    field: 'company2project.penalty_date_agreed_4',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.5th_penalty_date'),
                    field: 'company2project.penalty_date_agreed_5',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.percentage_of_completion'),
                    field: 'company2project.percentage_of_completion',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.start_date'),
                    width: '105px',
                    field: 'company2project.start_date',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.end_date'),
                    width: '105px',
                    field: 'company2project.end_date',
                    numeric: false,
                    html: false,
                }, {
                    label:  Vue.i18n.translate('table.invoices_submitted'),
                    field: 'company2project.invoices_submitted',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.additional_services_agreed'),
                    field: 'company2project.additional_services_agreed',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.as_build_doc_needed'),
                    field: 'company2project.as_build_doc_needed',
                    numeric: false,
                    html: false,
                    showAsCheckSubcontractors: true,
                }, {
                    label: Vue.i18n.translate('table.as_build_doc_rec_and_checked'),
                    field: 'company2project.as_build_doc_rec_and_checked',
                    numeric: false,
                    html: false,
                    showAsCheckSubcontractors: true,
                }, {
                    label: Vue.i18n.translate('table.warranty_value'),
                    field: 'company2project.warranty_value',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.auth_date'),
                    field: 'company2project.expiry_date',
                    numeric: false,
                    html: false,
                },
            ],
            dropzoneOptions: {
                url: '/',
                thumbnailWidth: 150,
                addRemoveLinks: true,
                maxFiles:3,
                headers: { "My-Awesome-Header": "header value" },
                dictDefaultMessage: Vue.i18n.translate('dropzone.dictDefaultMessage'),
                dictFallbackMessage: Vue.i18n.translate('dropzone.dictFallbackMessage'),
                dictFileTooBig: Vue.i18n.translate('dropzone.dictFileTooBig'),
                dictInvalidFileType: Vue.i18n.translate('dropzone.dictInvalidFileType'),
                dictResponseError: Vue.i18n.translate('dropzone.dictResponseError'),
                dictCancelUpload: Vue.i18n.translate('dropzone.dictCancelUpload'),
                dictUploadCanceled: Vue.i18n.translate('dropzone.dictUploadCanceled'),
                dictCancelUploadConfirmation: Vue.i18n.translate('dropzone.dictCancelUploadConfirmation'),
                dictRemoveFile: Vue.i18n.translate('dropzone.dictRemoveFile'),
                dictMaxFilesExceeded: Vue.i18n.translate('dropzone.dictMaxFilesExceeded')
            },
        }
    },
    mounted() {
        this.onLoadTable();
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        warnMsg(msg) {
            miniToastr.warn(msg, Vue.i18n.translate('messages.warn'), 5000);
        },
        onClickPriceList (row) {
            this.$store.commit('SET_CURRENT_COMPANY', row);
            this.$router.push({name: 'subcontractors_price_list', params: {id:this.$route.params.id, id2: row.id}});
        },
        openDocumentModal () {
            this.$refs.documentModal.show()
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let data = http.route(this.tableName + '?search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType + '&subcontractors=1&project_id=' + this.$route.params.id).get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;
                    var data = response.data;

                    data.forEach(field => {
                        if (field.company2project == null) {
                            field.company2project = {
                                'contract_done': '',
                                'performance_bond': '',
                                'performance_bond_received': '',
                                'penalty_for_late_payment': '',
                                'contract_currency': '',
                                'contract_value': '',
                                'penalty_date_agreed_1': '',
                                'penalty_date_agreed_2': '',
                                'penalty_date_agreed_3': '',
                                'penalty_date_agreed_4': '',
                                'penalty_date_agreed_5': '',
                                'percentage_of_completion': '',
                                'start_date': '',
                                'end_date': '',
                                'invoices_submitted': '',
                                'additional_services_agreed': '',
                                'as_build_doc_needed': '',
                                'as_build_doc_rec_and_checked': '',
                                'warranty_value': '',
                                'expiry_date': '',
                            }
                        }
                    });

                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onAddRow (name = null, company_id = null, subcontractor = false) {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.isSubcontractor = subcontractor;
            this.row = null;

            this.model.name = null;
            if (name != null) {
                this.model.name = name;
                this.model.company_id = company_id;
            }

            this.model.contract_done = false;
            this.model.performance_bond = false;
            this.model.performance_bond_value = null;
            this.model.performance_bond_received = false;
            this.model.performance_bond_received_date = null;
            this.model.warranty_bond = false;
            this.model.warranty_received = false;
            this.model.warranty_value = null;
            this.model.expiry_date = null;
            this.model.penalty_for_late_payment = null;
            this.model.contract_currency = null;
            this.model.contract_value = null;
            this.model.penalty_date_agreed_1 = null;
            this.model.penalty_date_agreed_1_description = null;
            this.model.penalty_date_agreed_2 = null;
            this.model.penalty_date_agreed_2_description = null;
            this.model.penalty_date_agreed_3 = null;
            this.model.penalty_date_agreed_3_description = null;
            this.model.penalty_date_agreed_4 = null;
            this.model.penalty_date_agreed_4_description = null;
            this.model.penalty_date_agreed_5 = null;
            this.model.penalty_date_agreed_5_description = null;
            this.model.percentage_of_completion = null;
            this.model.start_date = null;
            this.model.end_date = null;
            this.model.additional_services_agreed = null;
            this.model.invoices_submitted = null;
            this.model.submitted_documentation = false;
            this.model.submitted_date = null;
            this.model.as_build_doc_rec_and_checked = false;
            this.model.as_build_doc_needed = false;
            this.model.po_number = null;

            this.selectedCompany = null;
            this.selectedPM      = null;
            this.selectedCM      = null;

            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            if (typeof row.company2project.id == 'undefined') {
                this.onAddRow(row.name, row.id, true);
            } else {
                this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
                this.isSubcontractor = true;
                this.row = row;

                this.model.name = this.row.name;
                this.model.contract_done = Boolean(this.row.company2project.contract_done);
                this.model.performance_bond = Boolean(this.row.company2project.performance_bond);
                this.model.performance_bond_value = this.row.company2project.performance_bond_value;
                this.model.performance_bond_received = Boolean(this.row.company2project.performance_bond_received);
                this.model.performance_bond_received_date = this.row.company2project.performance_bond_received_date;
                this.model.warranty_bond = Boolean(this.row.company2project.warranty_bond);
                this.model.warranty_received = Boolean(this.row.company2project.warranty_received);
                this.model.warranty_value = this.row.company2project.warranty_value;
                this.model.expiry_date = this.row.company2project.expiry_date;
                this.model.penalty_for_late_payment = this.row.company2project.penalty_for_late_payment;
                this.model.contract_currency = this.row.company2project.contract_currency;
                this.model.contract_value = this.row.company2project.contract_value;
                this.model.penalty_date_agreed_1 = this.row.company2project.penalty_date_agreed_1;
                this.model.penalty_date_agreed_1_description = this.row.company2project.penalty_date_agreed_1_description;
                this.model.penalty_date_agreed_2 = this.row.company2project.penalty_date_agreed_2;
                this.model.penalty_date_agreed_2_description = this.row.company2project.penalty_date_agreed_2_description;
                this.model.penalty_date_agreed_3 = this.row.company2project.penalty_date_agreed_3;
                this.model.penalty_date_agreed_3_description = this.row.company2project.penalty_date_agreed_3_description;
                this.model.penalty_date_agreed_4 = this.row.company2project.penalty_date_agreed_4;
                this.model.penalty_date_agreed_4_description = this.row.company2project.penalty_date_agreed_4_description;
                this.model.penalty_date_agreed_5 = this.row.company2project.penalty_date_agreed_5;
                this.model.penalty_date_agreed_5_description = this.row.company2project.penalty_date_agreed_5_description;
                this.model.percentage_of_completion = this.row.company2project.percentage_of_completion;
                this.model.start_date = this.row.company2project.start_date;
                this.model.end_date = this.row.company2project.end_date;
                this.model.additional_services_agreed = this.row.company2project.additional_services_agreed;
                this.model.invoices_submitted = this.row.company2project.invoices_submitted;
                this.model.submitted_documentation = Boolean(this.row.company2project.submitted_documentation);
                this.model.submitted_date = this.row.company2project.submitted_date;
                this.model.as_build_doc_rec_and_checked = Boolean(this.row.company2project.as_build_doc_rec_and_checked);
                this.model.as_build_doc_needed = Boolean(this.row.company2project.as_build_doc_needed);
                this.model.po_number = this.row.company2project.po_number;

                this.$refs.saveModal.show();
            }
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            if (typeof this.row.company2project.id == 'undefined') {
                this.warnMsg(Vue.i18n.translate('messages.must_be_subcontractor'));
                return false;
            } else {
                this.$refs.deleteModal.show();
            }
        },
        saveAction (e) {
            e.preventDefault();

            let mdl = {
                name: this.model.name,
                company2project: {
                    contract_done: this.model.contract_done,
                    performance_bond: this.model.performance_bond,
                    performance_bond_value: this.model.performance_bond_value,
                    performance_bond_received: this.model.performance_bond_received,
                    performance_bond_received_date: this.model.performance_bond_received_date,
                    warranty_bond: this.model.warranty_bond,
                    warranty_received: this.model.warranty_received,
                    warranty_value: this.model.warranty_value,
                    expiry_date: this.model.expiry_date,
                    penalty_for_late_payment: this.model.penalty_for_late_payment,
                    contract_currency: this.model.contract_currency,
                    contract_value: this.model.contract_value,
                    penalty_date_agreed_1: this.model.penalty_date_agreed_1,
                    penalty_date_agreed_1_description: this.model.penalty_date_agreed_1_description,
                    penalty_date_agreed_2: this.model.penalty_date_agreed_2,
                    penalty_date_agreed_2_description: this.model.penalty_date_agreed_2_description,
                    penalty_date_agreed_3: this.model.penalty_date_agreed_3,
                    penalty_date_agreed_3_description: this.model.penalty_date_agreed_3_description,
                    penalty_date_agreed_4: this.model.penalty_date_agreed_4,
                    penalty_date_agreed_4_description: this.model.penalty_date_agreed_4_description,
                    penalty_date_agreed_5: this.model.penalty_date_agreed_5,
                    penalty_date_agreed_5_description: this.model.penalty_date_agreed_5_description,
                    start_date: this.model.start_date,
                    end_date: this.model.end_date,
                    additional_services_agreed: this.model.additional_services_agreed,
                    invoices_submitted: this.model.invoices_submitted,
                    submitted_documentation: this.model.submitted_documentation,
                    submitted_date: this.model.submitted_date,
                    as_build_doc_rec_and_checked: this.model.as_build_doc_rec_and_checked,
                    as_build_doc_needed: this.model.as_build_doc_needed,
                    po_number: this.model.po_number
                }
            }

            Object.keys(mdl.company2project).forEach(key => {
                if (mdl.company2project[key] === '') {
                    mdl.company2project[key] = null;
                }
            });

            if (this.row != null) {
                http.route('project/' +this.$route.params.id+ '/subcontractor/' + this.row.company2project.id).patch(mdl, true).then(response => {
                    if(!response.isError) {
                        this.onLoadTable()
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            } else {
                mdl['company_id'] = this.model.company_id;
                mdl['project_manager_id'] = this.model.project_manager_id;
                mdl['commercial_manager_id'] = this.model.commercial_manager_id;

                http.route('project/' +this.$route.params.id+ '/subcontractor').post(mdl, true).then(response => {
                    if(!response.isError) {
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                        this.$refs.saveModal.hide();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        deleteAction (button) {
            if (button == 1) {
                http.route('project/' +this.$route.params.id+ '/subcontractor/' + this.row.id).delete().then(response => {
                    if (!response.isError) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        onCompanySearch(search) {
            if (search == '') {
                this.currentCompany = [];
                
                return false;
            }

            this.isCompanyLoading = true;
            this.searchCompany(search, this);
        },
        searchCompany: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentCompany = response.data;
                }
                vm.isCompanyLoading = false;
            });
        }, 500),
        updateCompany(company) {
            this.selectedPM = null;
            this.selectedCM = null;
            this.currentPM  = [];
            this.currentCM  = [];
            
            this.model.company_id = (company != null) ? company.id : null;
        },
        clearSelectedCompany () {
            this.selectedCompany  = null;
            this.model.company_id = null;
        },
        onPMSearch(search) {
            if (search == '') {
                this.currentPM = [];
                
                return false;
            }

            this.isPMLoading = true;
            this.searchPMSearch(search, this);
        },
        searchPMSearch: _.debounce((search, vm) => {
            http.route('user/getall?get_all=1&search_select=' + search + '&filters[main_company_id]=' + vm.model.company_id).get().then(response => {
                if (response.data != false) {
                    vm.currentPM = response.data;
                }
                vm.isPMLoading = false;
            });
        }, 500),
        updatePM(user) {
            this.model.project_manager_id = (user == null) ? null : user.id;
        },
        clearSelectedPM () {
            this.selectedPM               = null;
            this.model.project_manager_id = null;
        },
        onCMSearch(search) {
            if (search == '') {
                this.currentCM = [];
                
                return false;
            }

            this.isCMLoading = true;
            this.searchCM(search, this);
        },
        searchCM: _.debounce((search, vm) => {
            let data = http.route('user/getall?search_select=' + search + '&filters[main_company_id]=' + vm.model.company_id).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentCM = response.data;
                }
                vm.isCMLoading = false;
            });
        }, 500),
        updateCM(user) {
            this.model.commercial_manager_id = (user == null) ? null : user.id;
        },
        clearSelectedCM () {
            this.selectedCM                  = null;
            this.model.commercial_manager_id = null;
        },
        onClickCheckSubcontractors (row, index, column) {
            if (row) {
                if (typeof row.company2project.id == 'undefined') {
                    this.warnMsg(Vue.i18n.translate('messages.must_be_subcontractor'));
                    return false;
                }

                var clone = Object.assign({}, row);
                if (column.indexOf('.') !== false) {
                    var cols = column.split('.');
                    var db_col = cols.pop();
                    var prefix = cols.join('.');

                    clone[prefix][db_col] = (clone[prefix][db_col] == null || clone[prefix][db_col] == 0 || clone[prefix][db_col] === false) ? 1 : 0;
                } else {
                    clone[column.toString()] = (clone[column.toString()] == null || clone[column.toString()] == 0  || !clone[column.toString()] === false) ? 1 : 0;
                }

                http.route('project/' +this.$route.params.id+ '/subcontractor/' + row.company2project.id).patch(clone, true).then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    }
                });
            }
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	select {
		-webkit-appearance:menulist-button;
		-moz-appearance:menulist-button;
	}
    .multiselect-custom {
        width: 300px !important;
        height: 40px !important;
    }
    .multiselect__input:focus {
        width: 100% !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/project/subcontractors/subcontractors.vue